module.exports = __webpack_public_path__ + "static/media/how-soc-md-mk-1.f0899352.png";